import * as types from '../actions/types'

import { convertFromDynamo } from "../libs/application";

const initialState = {
  complete: false,
  ethnicity: 'NNNNNNNNNNNNNNNNNNNNN',
  term: '',
  name: {
    firstName: '',
    lastName: ''
  },
  address: {},
  phones: {
    home: '',
    emergency: '',
    cell: '',
    work: ''
  },
  deltaId: '',
  gender: '',
  maritalStatus: '',
  dateOfBirth: '',
  email: '',
  hsName: '',
  hsGpa: '',
  hsDiploma: false,
  hsGed: false,
  hsForeignDiploma: false,
  colleges: [],
  collegeUnits: 0,
  collegeMajor: '',
  collegeGrad: false,
  degrees: [],
  edGoalDegree: false,
  edGoalCertificate: false,
  edGoalTransfer: false,
  sjdcEops: false,
  otherEops: false,
  sjdcDsps: false,
  motherEdLevel: '',
  fatherEdLevel: '',
  motherLanguage: '',
  fatherLanguage: '',
  fosterYouth: false,
  veteran: false,
  headOfHousehold: false,
  ab540: false,
  cashAid: false,
  calworks: false,
  dependents: '0'
};

function toggleConfirmation(formState, action) {
  return {
    ...formState,
    confirmations: formState.confirmations.map(confirmation => confirmation.id === action.id ? { ...confirmation, status: !confirmation.status} : confirmation)
  }
}

function updateApplication(applicationState, action) {
  return {
    ...applicationState,
    ...action.updates
  }
}

function addCollege(applicationState, action) {
  return {
    ...applicationState,
    colleges: [
      ...applicationState.colleges,
      action.newCollege
    ]
  }
}

function removeCollege(applicationState, action) {
  return {
    ...applicationState,
    colleges: applicationState.colleges.filter(college => action.collegeId !== college.id)
  };
}

function updateCollege(applicationState, action) {
  return {
    ...applicationState,
    colleges: applicationState.colleges.map(college => {
      if(action.collegeId !== college.id)
        return { ...college };
      return {
        ...college,
        ...action.updates
        };
    })
  };
}

function addDegree(applicationState, action) {
  return {
    ...applicationState,
    degrees: [
      ...applicationState.degrees,
      action.newDegree
    ]
  };
}

function removeDegree(applicationState, action) {
  return {
    ...applicationState,
    degrees: applicationState.degrees.filter(degree => action.degreeId !== degree.id)
  };
}

function updateDegree(applicationState, action) {
  return {
    ...applicationState,
    degrees: applicationState.degrees.map(degree => {
      if(action.degreeId !== degree.id)
        return { ...degree };
      return {
        ...degree,
        ...action.updates
      };
    })
  };
}

function setApplication(applicationState, action) {
  const { user } = action;
  const { ethnicity, gender, deltaId, email, name, address, phones, dateOfBirth } = user;
  return {
    ...applicationState,
    ethnicity,
    gender,
    name,
    address,
    deltaId,
    email,
    phones,
    dateOfBirth
  };
}

function setTerm(applicationState, action) {
  const { openTerm } = action;
  return {
    ...applicationState,
    termApplying: openTerm.appOpenForStudents ? openTerm.name : ''
  };
}

function setFetchedApplication(applicationState, action) {
  const { application } = action;
  return { ...applicationState, ...convertFromDynamo(application), complete: true }
}

function setApplicationSubmitted(applicationState, action) {
  const state = setApplicationComplete(applicationState);
  return setFetchedApplication(state, action);
}

function setApplicationComplete(applicationState) {
  return { ...applicationState, complete: true }
}

export const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_CONFIRMATION:
      return toggleConfirmation(state, action);
    case types.UPDATE_APPLICATION:
      return updateApplication(state, action);
    case types.ADD_COLLEGE:
      return addCollege(state, action);
    case types.REMOVE_COLLEGE:
      return removeCollege(state, action);
    case types.UPDATE_COLLEGE:
      return updateCollege(state, action);
    case types.ADD_DEGREE:
      return addDegree(state, action);
    case types.REMOVE_DEGREE:
      return removeDegree(state, action);
    case types.UPDATE_DEGREE:
      return updateDegree(state, action);
    case types.SET_USER:
      return setApplication(state, action);
    case types.OPEN_TERM_SUCCESS:
      return setTerm(state, action);
    case types.FETCH_APPLICATION_SUCCESS:
      return setFetchedApplication(state, action);
    case types.SUBMIT_APPLICATION_SUCCESS:
      return setApplicationSubmitted(state, action);
    default:
      return state;
  }
};

export default applicationReducer;